import TemplatesCustomTable from "./TemplatesCustomTable";

export default function Templates() {
  return <TemplatesCustomTable />;
}
